module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point01_03_travel-2e0cb834207fc5d9e3be1bfbf78ef36e.jpg";